import React,{useState} from 'react'

const Sidebar = ({ isSidebarOpen }) => {
    const sidebarClassName = isSidebarOpen ? 'side-bar open' : 'side-bar';


  return (
    <div className={sidebarClassName}>

        <div className="side-box">
            <li className='menu-btn'>
                <img src="./Assets/how-to-use.png" alt="" />
                <a href="/Home">How To Use</a>
            </li>
            <li className='menu-btn'>
                <img src="./Assets/about.png" alt="" />
                <a href="/About">About Us</a>
            </li>
            <li className='menu-btn'>
                <img src="./Assets/web-dev.png" alt="" />
                <a href="/Website-Development-Sector">Web-Dev Sector</a>
            </li>
            <li className='menu-btn'>
                <img src="./Assets/ai.png" alt="" />
                <a href="/Artificial-Intelligence-Sector">A.I Sector</a>
            </li>
            <li className='menu-btn'>
                <img src="./Assets/contact.png" alt="" />
                <a href="/Contact-BlueLoop">Contact Us</a>
            </li>
            <li className='menu-btn'>
                <img src="./Assets/newsfeed.png" alt="" />
                <a href="/Newsfeeds">News Feeds</a>
            </li>
            
        </div>
    </div>
  )
}

export default Sidebar